import { Button, SxProps, Typography, TypographyProps } from "@mui/material";
import { ReactComponent as OpenLinkInNewTabIcon } from "../../../icons/open-in-new-tab-icon.svg";
import NewTabLink from "./NewTabLink";

type BaseProps = {
  text: string;
  buttonSx?: SxProps;
  TypographyProps?: TypographyProps;
  withIcon?: boolean;
};

type Props = BaseProps &
  ({ to: string; onClick?: never } | { onClick: () => void; to?: never });

const NewTabLinkButton = ({
  to,
  text,
  buttonSx,
  TypographyProps = {},
  withIcon = false,
  onClick,
}: Props) => {
  if (!to && !onClick)
    return <Typography {...TypographyProps}>{text}</Typography>;

  return (
    <Button
      sx={{ fontSize: "23px", fontWeight: 500, ...buttonSx }}
      endIcon={withIcon ? <OpenLinkInNewTabIcon /> : null}
      {...(onClick && { onClick })}
    >
      {onClick ? (
        <Typography
          variant="header"
          sx={{ color: (theme) => theme.palette.primary.main }}
          {...TypographyProps}
        >
          {text}
        </Typography>
      ) : (
        <NewTabLink to={to} text={text} TypographyProps={TypographyProps} />
      )}
    </Button>
  );
};

export default NewTabLinkButton;
